import { render } from "./InfoTop.vue?vue&type=template&id=281cf42e&scoped=true"
import script from "./InfoTop.vue?vue&type=script&lang=js"
export * from "./InfoTop.vue?vue&type=script&lang=js"

import "./InfoTop.vue?vue&type=style&index=0&id=281cf42e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-281cf42e"

export default script